module.exports = __webpack_public_path__ + "static/media/icon_tag.95f1d60c.svg";